import { createMuiTheme, Theme } from "@material-ui/core";

export default class DialogDatePickerViewStyle {

    pickerTheme : Theme = createMuiTheme({
        overrides: 
        {
            MuiFormLabel:
            {
                root:
                {
                    fontWeight: 300
                }
            },
            MuiInputBase:
            {
                input:
                {
                    fontWeight: 300
                }
            },
            MuiDialogActions:
            {
                root:
                {
                    display: 'none'
                }
            },
            //@ts-ignore
            MuiPickersDay: {
                // TODO: Check this
                '&$selected': {
                    color:'white',
                }
            },
            MuiPickersToolbarText:
            {
                toolbarTxt: {
                    color:'white'
                },

                toolbarBtnSelected: {
                    color:'white'
                }
            },
        },
        palette: 
        {
            primary: 
            {
              main: 'rgb(26, 165, 207)',
              dark: 'rgb(26, 165, 207)'
            }
        }
    });
}